import axios from 'axios';
import { API_DOMAIN } from '../magic-values';
import { authInterceptor } from './auth-interceptor';

export const axiosInstance = axios.create({
  baseURL: `${API_DOMAIN}`,
});

axiosInstance.interceptors.request.use(authInterceptor.intercept);
